import './FilteredTable.css';
import { Link } from 'react-router-dom';
import { StatusIcons } from './StatusIcons';
import { Container, Row, Col } from 'reactstrap';
import Mute from '../../../Shared/Mute';
import Bookmark from '../../../Shared/Bookmark';
import { renderFilter } from '../../../Shared/TextHelpers';
import React, { useContext } from 'react';
import PracticePims from './PracticePims';
import PracticeGroup from './PracticeGroup';
import CityStateProvince from './CityStateProvince';
import UserAssignment from '../../../Shared/UserAssignment';
import StatusPill from './StatusPill';
import { PracticeListPermissionsContext } from '../PracticesList';

// TODO: I broke this up but could maybe use some more, idk
const PracticeListItem = ({
    filter = '',
    searchCustomIds = false,
    searchPartnerOfferings = false,
    searchPracticePims = false,
    // statusContent
    statusBackgroundClass,
    statusBadgeText,
    // pratice
    practice,
}) => {
    const { canAssignUsers, canMutePractices } = useContext(
        PracticeListPermissionsContext
    );

    const assignmentProps = canAssignUsers && {
        practiceId: practice.id,
        practiceName: practice.name,
        assignedAccountInitials: practice.assignedAccountInitials,
        assignedAccountId: practice.assignedAccountId,
        isAssignedToCurrentUser: practice.isAssignedToCurrentUser,
    };
    const muteProps = canMutePractices && {
        id: practice.id,
        name: practice.name,
        muteUntil: practice.muteUntil,
        muteNote: practice.muteNote,
    };
    const bookmarkProps = {
        practiceId: practice.id,
        isBookmarked: practice.isBookmarked,
    };
    const cityStateProvinceProps = {
        practiceCity: practice.city,
        filter,
        practiceStateProvince: practice.stateProvince,
    };
    const practiceGroupProps = {
        practiceCity: practice.city,
        practiceStateProvince: practice.stateProvince,
        filter,
        practiceGroupName: practice.groupName,
    };
    const statusPillProps = {
        statusBadgeText,
        isConversionPractice: practice.isConversionPractice,
    };

    const statusIconsSmScreen = {
        allowConversionPrep: practice.allowConversionPrep,
        allowLeadsGeneration: practice.allowLeadsGeneration,
        size: 'lg',
        status: practice.status,
        isCloudPims: practice.isCloudPims,
    };
    const statusIconsLgScreen = { ...statusIconsSmScreen, size: 'sm' };

    // 40 characters makes it force to one line, we were gretting overflow errors
    // TODO: implement a better fix for this
    const truncate = (string = '', limit = 40) => {
        if (string?.length <= limit) return string;
        return string?.slice(0, limit) + '...';
    };

    const PracticeTitle = () => (
        <Col lg="8" md="12" className="pt-2">
            <h5 title={practice?.name}>
                {renderFilter(truncate(practice?.name), filter)}
            </h5>
        </Col>
    );

    const PraticeCityStateAndPracticeGroup = () => (
        <Col lg="8" xs="12" className="py-1">
            <span className="text-14 d-none d-md-block">
                <CityStateProvince {...cityStateProvinceProps} />
                <PracticeGroup {...practiceGroupProps} />
            </span>
            {/* TODO: there are better ways to do this conditional css */}
            <span className="text-12 d-md-none">
                <CityStateProvince {...cityStateProvinceProps} />
                <PracticeGroup {...practiceGroupProps} />
            </span>
        </Col>
    );

    const OfferingsSection = () => (
        <Col lg="8" md="12" className="text-left mt-2">
            <h5 className="">Offerings</h5>

            {practice.offeringInfo?.map((i, x) => {
                let { partner, partnerOffering, partnerCustomId } = i;

                partnerCustomId = renderFilter(partnerOffering, filter);

                if (searchPartnerOfferings) {
                    partner = renderFilter(partner, filter);
                    partnerOffering = renderFilter(partnerOffering, filter);
                }

                return (
                    // TODO: there is no unique id to use as a key here
                    <p key={x}>
                        {canAssignUsers && (
                            <span>
                                {partner}
                                &nbsp;|&nbsp;
                            </span>
                        )}

                        <span>{partnerOffering}</span>

                        {searchCustomIds && partnerCustomId && (
                            <span>&nbsp;|&nbsp; partnerCustomId</span>
                        )}
                    </p>
                );
            })}
        </Col>
    );

    return (
        <Container className="mb-4 hoverable hover-parent text-white text-center">
            <Link
                to={`/practices/${practice.id}`}
                style={{
                    textDecoration: 'none',
                    color: 'white',
                }}>
                {/* TODO: I am not sure that a lot of this HTML / Bootstrap actually works... */}
                {/* ...because when I look on mobile devtools it just falls apart. */}
                <Row
                    className={`rounded-top ${getBackgroundStyle()} shadow-sm mr-0`}>
                    {PracticeTitle()}

                    <Col
                        lg="4"
                        md="12"
                        className="py-2 mx-auto d-none d-lg-block text-14">
                        <div
                            className={`d-none d-md-block mx-auto text-light p-1 sc-rounded ${statusBackgroundClass}`}>
                            <StatusPill {...statusPillProps} />
                        </div>
                    </Col>

                    {PraticeCityStateAndPracticeGroup()}

                    {/* TODO: is there a way to programtically render these based on screen size? */}
                    <Col
                        md="3"
                        sm="4"
                        xs="5"
                        className="py-2 d-lg-none mx-auto">
                        <div
                            className={`mx-auto text-light p-1 rounded ${statusBackgroundClass}`}>
                            <StatusPill {...statusPillProps} />
                        </div>
                        <div className="py-2">
                            <StatusIcons {...statusIconsSmScreen} />
                        </div>
                    </Col>

                    <Col className="d-none d-lg-block">
                        <StatusIcons {...statusIconsLgScreen} />
                    </Col>
                    {searchPracticePims && (
                        <Col lg="8" md="12" className="text-center mt-2">
                            <PracticePims
                                pims={practice.pims}
                                filter={filter}
                            />
                        </Col>
                    )}

                    {practice.offeringInfo?.length > 0 &&
                        searchCustomIds &&
                        searchPartnerOfferings &&
                        OfferingsSection()}
                </Row>
            </Link>
            <Row
                className={`text-16 rounded-bottom ${getBackgroundStyle()} shadow-sm mt-1 mr-0`}>
                <Col className="py-2">
                    <Row className="text-light">
                        <Col>
                            <Bookmark {...bookmarkProps} />
                        </Col>
                        <Col>
                            {canAssignUsers && (
                                <UserAssignment {...assignmentProps} />
                            )}
                        </Col>
                        <Col>{canMutePractices && <Mute {...muteProps} />}</Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

const getBackgroundStyle = () => `fake-glass-${process.env.REACT_APP_INDUSTRY}`;

export default React.memo(PracticeListItem);
